import React from 'react';
import classnames from 'classnames';

const SizeSelector = ({size, inStock, isSelected, onClick}) => (
  <div className="size-selector">
    <button
      className={classnames('size-selector__btn', {
        'size-selector__btn--is-selected': isSelected,
      })}
      disabled={!inStock}
      onClick={onClick}
    >
      {size}
    </button>
  </div>
);

export default SizeSelector;



// WEBPACK FOOTER //
// ./assets/scripts/components/ProductSelector/SizeSelector.js